import { FORGET_PASSWORD,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAILURE } from "../../Actions/types";

const initialState = {
  loader: false,
  error: false,
  data: null,
};
function forgetPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case FORGET_PASSWORD:
      return { ...state, data: action.payload, loader: true };

    case FORGET_PASSWORD_SUCCESS:
      return { ...state, data: action.payload, loader: false };

    case FORGET_PASSWORD_FAILURE:
      return { ...state, error: true, loader: false };

    default:
      return state;
  }
}

export default forgetPasswordReducer;
